import { render, staticRenderFns } from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=template&id=2cff66b2&scoped=true"
import script from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=script&lang=js"
export * from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=script&lang=js"
import style0 from "./values-by-insrer-and-non-insurance-summary.vue?vue&type=style&index=0&id=2cff66b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff66b2",
  null
  
)

export default component.exports